<script lang="ts">
    import ProspectMultiselectCity from './prospect-multiselect-city.svelte'
    import InlineSelect from '../_common/inline-select.svelte'
    import ProspectMultiselectCategory from './prospect-multiselect-category.svelte'
    import dayjs from 'dayjs'
    import { SearchQueryRepository } from '../../modules/prospectApi/search-query/search-query.repository'
    import { SearchQueryService } from '../../modules/prospectApi/search-query/search-query.service'
    import ProspectCard from './prospect-card.svelte'
    import { onMount } from 'svelte'
    import type { SearchItem } from '../../modules/prospectApi/search-items/search-items'
    import Popover from '../_common/popover.svelte'
    import ProspectAudienceForm from './prospect-audience-form.svelte'
    import { AudiencesRepository } from '../../modules/eventsApi/audiences/audiences.repository'
    import { AudiencesService } from '../../modules/eventsApi/audiences/audiences.service'
    import type { Audience } from '../../modules/eventsApi/audiences/audience'
    import ProspectMultiselectSearches from './prospect-multiselect-searches.svelte'

    const entityRep = new SearchQueryRepository()
    const entityS = new SearchQueryService(entityRep)

    const audR = new AudiencesRepository()
    const audS = new AudiencesService(audR)
    let audiences: Audience[] = []

    async function loadAudiences() {
        audiences = await audS.getAll()
    }

    let sortList = [
        {
            value: '0',
            label: 'Ordenação padrão',
        },
        {
            value: '1',
            label: 'Ordem de inclusão - crescente',
        },
        {
            value: '2',
            label: 'Ordem de inclusão - decrescente',
        },
        {
            value: '3',
            label: 'Avaliações no Google - crescente',
        },
        {
            value: '4',
            label: 'Avaliações no Google - decrescente',
        },
    ]
    let sort = sortList[0]
    const optionsTriple = [
        { label: '-', value: '-' },
        { label: 'não', value: 'não' },
        { label: 'sim', value: 'sim' },
    ]
    let socios = null
    let email = null
    let cnpj = null
    let exported = null
    let included = null
    let toggleSelection = false
    let result: SearchItem[] = []
    let showAlert = false
    let cities: { label: any; value: any }[] = []
    let categories: { label: any; value: any }[] = []
    let searches: { label: any; value: any }[] = []

    function getUTCDateFromString(date: string) {
        let serial = date.split('-')
        return new Date(+serial[0], +serial[1] - 1, +serial[2])
    }

    function audienceFilter(selected: { audienceId: string }[]) {
        let found: any[] = []
        for (const audience of audiences) {
            if (selected.find((el) => el.audienceId === audience.audienceId)) found.push(audience)
        }
        return found
    }

    async function search() {
        const filter = {
            // from: getUTCDateFromString(from),
            // to: getUTCDateFromString(to),
            socios: socios === 'sim' ? true : socios === 'não' ? false : undefined,
            email: email === 'sim' ? true : email === 'não' ? false : undefined,
            exported: exported === 'sim' ? true : exported === 'não' ? false : undefined,
            included: included === 'sim' ? true : included === 'não' ? false : undefined,
            cnpj: cnpj === 'sim' ? true : cnpj === 'não' ? false : undefined,
            cities: cities.length > 0 ? cities.map((el) => el.value) : undefined,
            searches: searches.length > 0 ? searches.map((el) => el.value) : undefined,
            categories: categories.length > 0 ? categories.map((el) => el.value) : undefined,
            order: sort.value,
        }
        result = await entityS.getAll(filter)
        console.log('prospects', result)
        toggleSelection = false
        itemClicked()
        showAlert = result.length >= 500
    }

    let startFrom: Date = new Date()
    let startTo: Date = new Date()
    startFrom.setDate(1)
    let from = dayjs(startFrom).format('YYYY-MM-DD')
    let to = dayjs(startTo).format('YYYY-MM-DD')

    let totalSelected = 0
    let businessId: string[] = []
    function itemClicked() {
        businessId = result.filter((el) => el.selected).map((el) => el.businessId)
        totalSelected = businessId.length
    }

    let _showForm = false
    function hideForm(event) {
        _showForm = false
    }

    function showForm() {
        _showForm = true
    }

    onMount(async () => {
        await loadAudiences()
        detectParams()
        await search()
    })

    function detectParams() {
        const urlParams = new URLSearchParams(window.location.search)
        const searchId = urlParams.get('searchId')
        searches = []
        if (searchId) searches.push({ label: '', value: searchId })
    }
</script>

{#if _showForm}
    <Popover on:close={hideForm} title="Público" height="400px" width="670px">
        <ProspectAudienceForm {businessId} on:close={hideForm} />
    </Popover>
{/if}

<div class="board">
    <div class="filter config-box scroll-dark">
        <!-- <div class="option">
            <div class="label">Leads captados entre</div>
            <div class="input-group input-group-sm">
                <input type="date" bind:value={from} class="form-control" />
                <label for="" class="input-group-text">&nbsp;&nbsp;e&nbsp;&nbsp;</label>
                <input type="date" bind:value={to} class="form-control" />
            </div>
        </div> -->
        <div class="option">
            <div class="label">Prospecções</div>
            <ProspectMultiselectSearches bind:selected={searches} />
        </div>
        <!-- <div class="option">
            <div class="label">Cidades</div>
            <ProspectMultiselectCity bind:selected={cities} />
        </div>
        <div class="option">
            <div class="label">Categorias</div>
            <ProspectMultiselectCategory bind:selected={categories} />
        </div> -->
        <div class="option">
            <div class="label">Deve possuir dados da Receita</div>
            <InlineSelect small={true} options={optionsTriple} bind:value={cnpj} />
        </div>
        <div class="option">
            <div class="label">Deve possuir nome do sócio</div>
            <InlineSelect small={true} options={optionsTriple} bind:value={socios} />
        </div>
        <div class="option">
            <div class="label">Deve possuir e-mail</div>
            <InlineSelect small={true} options={optionsTriple} bind:value={email} />
        </div>
        <!-- <div class="option">
            <div class="label">Já foi exportado</div>
            <InlineSelect small={true} options={optionsTriple} bind:value={exported} />
        </div> -->
        <div class="option">
            <div class="label">Já foi incluído em um público</div>
            <InlineSelect small={true} options={optionsTriple} bind:value={included} />
        </div>
        <div class="option">
            <div class="label">Ordenção</div>
            <select class="form-select form-select-sm" bind:value={sort}>
                <option value="" />
                {#each sortList as item}
                    <option value={item}>{item.label}</option>
                {/each}
            </select>
        </div>
        <div class="act">
            <button on:click={search} class="btn btn-primary">Buscar</button>
        </div>
    </div>
    <div class="board_content">
        <div class="act">
            <div class="form-check">
                <input
                    class="form-check-input"
                    bind:checked={toggleSelection}
                    on:change={itemClicked}
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">marcar todos </label>
            </div>
            <div class="spacer" />
            <div class="total pe-2">Encontrados: {result.length} | Selecionados: {totalSelected}</div>
            <!-- <div class="btn btn-secondary me-2">Baixar seleção</div> -->
            <div class="btn btn-primary" on:click={showForm}>Adicionar a um Público ({totalSelected})</div>
        </div>
        {#if showAlert}
            <div class="limit alert alert-warning">
                <div>Sua busca retornou muitos resultados. Exibindo os primeiros 500.</div>
                <div class="spacer" />
                <button class="btn" on:click={() => (showAlert = false)}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        {/if}
        <div class="cards scroll-dark">
            {#each result as item}
                <ProspectCard
                    audiences={audienceFilter(item.audiences)}
                    business={item.business}
                    bind:included={item.included}
                    bind:selected={item.selected}
                    {toggleSelection}
                    on:toggle={itemClicked}
                />
            {/each}
        </div>
    </div>
</div>

<style>
    .board {
        height: 100%;
        overflow: hidden;
        display: flex;
        padding-top: 16px;
        position: relative;
    }
    .filter {
        overflow: auto;
        display: flex;
        flex-direction: column;
        flex: 0 0 330px;
        height: 100%;
        max-height: 100%;
        color: #bbb;
    }
    .filter .option {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
    }
    .filter .option .label {
        margin-bottom: 4px;
    }
    .filter .act {
        display: flex;
        justify-content: center;
    }
    .board_content {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        padding-left: 16px;
    }
    .board_content .total {
        color: #aaaaaa;
    }
    .board_content .act {
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid #99999925;
        margin-bottom: 8px;
    }
    .board_content .cards {
        display: flex;
        flex-wrap: wrap;
        overflow-y: auto;
    }
    .board_content .limit {
        display: flex;
        align-items: center;
    }
    .board_content .limit button {
        font-size: 18px;
    }
</style>
